import {
  SET_FILTER_DROPDOWN_SHOW,
  SET_FILTER_VALUE,
  SET_FORM_CONTROL_SHOW,
  RESET_FILTER,
} from './types';

export const setFilterDropdownShow = show => ({
  type: SET_FILTER_DROPDOWN_SHOW,
  show,
});

export const setFilterValue = filterValue => ({
  type: SET_FILTER_VALUE,
  filterValue,
});

export const setFormControlShow = (show, filterValue) => ({
  type: SET_FORM_CONTROL_SHOW,
  show,
  filterValue,
});

export const resetFilter = () => ({
  type: RESET_FILTER,
});

const newFilter = {
  setFilterDropdownShow,
  setFilterValue,
  setFormControlShow,
  resetFilter,
};

export default newFilter;
